import { useEffect, useState } from "react";
import { api } from "@/api";
import PageHero from "@/components/PageHero";
import Section from "@/components/Section";
import Reveal from "@/components/Reveal";

function formatDate(d) {
  if (!d) return "";
  const dt = new Date(d);
  if (isNaN(dt)) return d;
  return dt.toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
}

export default function Journey() {
  const [milestones, setMilestones] = useState([]);
  useEffect(() => {
    api.get("/milestones").then((r) => setMilestones(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div data-testid="journey-page">
      <PageHero
        eyebrow="Our Journey"
        title="Every milestone, on the record."
        lede="From our incorporation in October 2024 onwards — the milestones that define the growth of Roy Career Solutions Private Limited."
      />

      <section className="py-24 lg:py-32" data-testid="journey-timeline">
        <div className="container-rcs">
          {milestones.length === 0 ? (
            <Section eyebrow="Timeline" title="Our story is just beginning." lede="Milestones will be published here as the company grows." />
          ) : (
            <ol className="relative mx-auto max-w-3xl space-y-16 border-l border-gold/40 pl-10 sm:pl-14">
              {milestones.map((m, i) => (
                <Reveal key={m.id} delay={i * 0.08}>
                  <li className="relative" data-testid={`journey-milestone-${i}`}>
                    <span className="absolute -left-[47px] top-1.5 flex h-4 w-4 items-center justify-center rounded-full border-2 border-gold bg-ivory sm:-left-[63px]">
                      <span className="h-1.5 w-1.5 rounded-full bg-gold" />
                    </span>
                    <div className="rounded-2xl border border-navy-900/10 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-gold/50 hover:shadow-[0_18px_40px_-18px_rgba(11,19,43,0.28)]">
                      <div className="flex flex-wrap items-center gap-3">
                        <span className="rounded-full bg-navy-950 px-4 py-1 font-mono text-xs tracking-[0.15em] text-gold">{m.year}</span>
                        {m.category && (
                          <span className="rounded-full border border-gold/40 px-4 py-1 text-[11px] font-semibold uppercase tracking-wider text-gold-dark">
                            {m.category}
                          </span>
                        )}
                        <span className="text-xs text-slate-500">{formatDate(m.date)}</span>
                      </div>
                      <h2 className="mt-4 font-serif text-2xl text-navy-900">{m.title}</h2>
                      {m.description && (
                        <p className="mt-3 text-sm leading-relaxed text-slate-600">{m.description}</p>
                      )}
                    </div>
                  </li>
                </Reveal>
              ))}
            </ol>
          )}
        </div>
      </section>

      <section className="bg-navy-950 py-20" data-testid="journey-future">
        <div className="container-rcs">
          <Section
            dark
            eyebrow="The Road Ahead"
            title="Building for the long term."
            lede="Brand launches, programme launches, technology milestones, partnerships and new markets — the RCS journey is designed to compound over years, not quarters."
          />
        </div>
      </section>
    </div>
  );
}
